/** Textes « formulaireClient » — le français fait foi. */
export const formulaireClient = {
  modifierTitre: (nom: string) => `Modifier ${nom}`,
  modificationImpossible: 'Modification impossible',
  creationImpossible: 'Création impossible',
  nouveauClient: 'Nouveau client',
  type: 'Type',
  particulier: 'Particulier',
  societe: 'Société',
  raisonSociale: 'Raison sociale',
  raisonSocialeObligatoire: 'La raison sociale est le seul champ obligatoire.',
  compteATerme: 'Compte à terme — paie à 30 jours',
  registreCommerce: 'Registre de commerce',
  nif: 'NIF',
  nis: 'NIS',
  articleImposition: "Article d'imposition",
  quatreLignes: 'Ces quatre lignes sont imprimées sur la facture, sous « DOIT ».',
  nom: 'Nom',
  nomObligatoire: 'Le nom est le seul champ obligatoire.',
  prenom: 'Prénom',
  dateNaissance: 'Date de naissance',
  dateNaissanceAide: 'Sert au contrôle des 28 ans (article 01).',
  dateNaissanceManquante: "Manquante — l'âge de l'article 01 ne pourra pas être vérifié.",
  lieuNaissance: 'Lieu de naissance',
  telephone: 'Téléphone',
  telephoneManquant: 'Manquant — personne à joindre si la voiture ne rentre pas.',
  email: 'E-mail',
  adresse: 'Adresse',
  typePiece: 'Type de pièce',
  pieceCin: "Carte d'identité",
  piecePc: 'Permis de conduire',
  piecePsp: 'Passeport',
  pieceCm: 'Carte militaire',
  numeroPiece: 'N° de la pièce',
  pieceManquante: "Manquant — le contrat s'imprimera sans pièce d'identité.",
  delivreeLe: 'Delivree le',
  delivreeA: 'Delivree a',
  numeroPermis: 'N° du permis',
  permisDelivreLe: 'Permis délivré le',
  permisAide: "Sert au contrôle des 5 ans d'ancienneté (article 01).",
  permisManquant: "Manquante — l'ancienneté de l'article 01 ne pourra pas être vérifiée.",
  ficheIncomplete: "Fiche incomplète — vous pouvez quand même l'enregistrer",
  pasTelephone: 'Pas de téléphone : personne à joindre si la voiture ne rentre pas.',
  pasPiece: "Pas de numéro de pièce : le contrat s'imprimera sans pièce d'identité.",
  niNaissanceNiPermis: 'Ni date de naissance ni date de permis',
  pasNaissance: 'Pas de date de naissance',
  pasPermis: 'Pas de date de permis',
  article01Sep: ' : ',
  aucuneLocation: 'aucune location ne pourra être enregistrée',
  article01Fin: " pour ce client tant que c'est manquant — l'article 01 ne se déroge pas sur une donnée absente.",
  completez: 'Complétez la fiche quand le client passera avec ses papiers : « Clients » puis « Modifier ».',
  enregistrement: 'Enregistrement…',
  enregistrerCorrections: 'Enregistrer les corrections',
  creerClient: 'Créer le client',
};
